import { useContext } from "react"
import { Button } from "../../components/common/button/Button"
import { Seperator } from "../../components/common/seperator/seperator"
import { Link, useLocation } from "react-router-dom"
import { AppContext, AppContextInterface } from "../../state/ContextProvider"
import { checkPath } from '../../utils/validation-utils'
import { AppointmentBookedLoader } from "../Loaders/AppointmentBookedLoader"

const CouldntFindVehicleConfirmation = () => {
  const { search } = useLocation()
  const {
    state: { dealershipUrl, lead, appointmentDetails: { dealership } },
    actions: { resetState }
  } = useContext(AppContext) as AppContextInterface

  const BASE_URL = `${window.location.origin}`

  if (Object.keys(lead).length === 0) {
    return <AppointmentBookedLoader />
  }

  return (
    <div className="no-vehicle-comfrimation-container">
      <div className="no-vehicle-confirmation-header-container">
        <h2 className="no-vehicle-confirmation-details-heading">
          Your valuation has been requested.
        </h2>
      </div>
      <div className="no-vehicle-confirmation-inner-container">
        <p className="no-vehicle-confirmation-details-paragraph">
          We have received your details and our <strong>{dealership}</strong> dealership will be in touch soon. Thank you for choosing us to sell your vehicle to us.
        </p>
      </div>
      <Seperator />
      {dealershipUrl ? (
        <>
          <div className="no-vehicle-confirmation-dealership">
            <p>Need help? Contact your dealership</p>
            <a
              className="no-underline"
              target="_blank"
              rel="noopener noreferrer"
              href={dealershipUrl}
            >
              <Button type="button" variant="white" id="contact-dealership">
                CONTACT DEALERSHIP
              </Button>
            </a>
          </div>
        </>
      ) : null}
      <div className="no-vehicle-confirmation-another-vehicle">
        <Link className="text-link" to={checkPath(search)}>
          <Button onClick={() => resetState()} type="button" variant="blue" id="value-another-vehicle">
            VALUE ANOTHER VEHICLE
          </Button>
        </Link>
      </div>
      <div className="tag-container">
        <a
          href={BASE_URL}
          className="change-vehicle-tag"
        >
          Go to the main site
        </a>
      </div>
    </div>
  )
}

export default CouldntFindVehicleConfirmation
